import { ClasePerdida } from '../../models/clase-perdida';

/* NgRx */
import { createAction, props } from '@ngrx/store';
import { MateriaMin } from 'src/app/unidad-buscar/models/unidad-setup';

export const loadClasesPerdidasGlobalSuccess = createAction(
  '[ClasePerdida API] Load UnidadMaterias Success',
  props<{ perdidasGlobal: ClasePerdida[] }>()
);

export const loadClasesPerdidasGlobalFailure = createAction(
  '[ClasePerdida API] Load UnidadMaterias Fail',
  props<{ error: string }>()
);

export const loadUnidadMateriasSuccess = createAction(
    '[ClasePerdida API] Load UnidadMaterias Success',
    props<{ materias: MateriaMin[] }>()
  );
  
  export const loadUnidadMateriasFailure = createAction(
    '[ClasePerdida API] Load UnidadMaterias Fail',
    props<{ error: string }>()
  );

export const loadClasePerdidasSuccess = createAction(
  '[ClasePerdida API] Load ClasePerdidas Success',
  props<{ clasePerdidas: ClasePerdida[] }>()
);

export const loadClasePerdidasFailure = createAction(
  '[ClasePerdida API] Load ClasePerdidas Fail',
  props<{ error: string }>()
);

export const deleteClasePerdidaSuccess = createAction(
  '[ClasePerdida API] Delete ClasePerdida Success',
  props<{ clasePerdida: ClasePerdida }>()
);

export const deleteClasePerdidaFailure = createAction(
  '[ClasePerdida API] Delete ClasePerdida Fail',
  props<{ error: string }>()
);

export const updateClasePerdidaSuccess = createAction(
  '[ClasePerdida API] Update ClasePerdida Success',
  props<{ clasePerdida: ClasePerdida }>()
);

export const updateClasePerdidaFailure = createAction(
  '[ClasePerdida API] Update ClasePerdida Fail',
  props<{ error: string }>()
);

export const createClasePerdidaSuccess = createAction(
  '[ClasePerdida API] Create ClasePerdida Success',
  props<{ clasePerdida: ClasePerdida }>()
);

export const createClasePerdidaFailure = createAction(
  '[ClasePerdida API] Create ClasePerdida Fail',
  props<{ error: string }>()
);
